import React from 'react';

import classes from './RenewalPaymentInfo.module.scss';
import { getPriceView } from '../../../../shared/utils/stringUtils';
import {
  BILLING_PERIOD_TYPE,
  BillingPeriodType,
} from '../../../constants/billingPeriodType';

type RenewalPaymentInfoProps = {
  billingPeriodType: BillingPeriodType;
  monthlyRenewalPrice: number | null;
  monthlyRenewalPriceFinal: number | null;
};

const titles = {
  [BILLING_PERIOD_TYPE.MONTHLY]: {
    title: 'Auto-Renew:',
    period: 'per month',
  },
  [BILLING_PERIOD_TYPE.DAILY]: {
    title: 'One-Time Payment:',
    period: 'per scan',
  },
};

const RenewalPaymentInfo = ({
  billingPeriodType,
  monthlyRenewalPrice,
  monthlyRenewalPriceFinal,
}: RenewalPaymentInfoProps) => {
  return (
    <div className={classes.container}>
      <p className={classes.title}>{titles[billingPeriodType].title}</p>&nbsp;
      <div className={classes.priceContainer}>
        {monthlyRenewalPrice !== monthlyRenewalPriceFinal && (
          <p className={classes.oldPrice}>{getPriceView(monthlyRenewalPrice)}</p>
        )}
        <p className={classes.description}>
          <span className={classes.price}>{getPriceView(monthlyRenewalPriceFinal)}</span>
          &nbsp;/&nbsp;{titles[billingPeriodType].period}
        </p>
      </div>
    </div>
  );
};

export { RenewalPaymentInfo };
